<template functional>
  <div :class="$style.formRow">
    <div
      v-if="slots().left"
      :class="$style.left"
      :style="{ width: `${props.ratio[0] * 100}%` }"
    >
      <slot name="left" />
    </div>

    <div
      v-if="slots().right"
      :class="$style.right"
      :style="{ width: `${props.ratio[1] * 100}%` }"
    >
      <slot name="right" />
    </div>

    <div :class="$style.full">
      <slot />
    </div>
  </div>
</template>

<style lang="scss" module>
$centerGap: 20px;

.formRow {
  width: 100%;
  margin: 30px auto 10px;
  position: relative;

  &::after {
    content: '';
    display: block;
    clear: both;
  }
}

.left,
.right {
  position: relative;
  box-sizing: border-box;

  @media screen and (max-width: 900px) {
    width: 100% !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
}

.left {
  float: left;
  padding-right: $centerGap / 2;
}

.right {
  float: right;
  padding-left: $centerGap / 2;
}

.full {
  width: 100%;
}
</style>

<script>

export default {
  props: {
    ratio: {
      type: Array,
      default: () => [0.3, 0.7],
      validator(value) {
        return value.length === 2 && value.reduce((a, b) => a + b, 0) === 1;
      },
    },
  },
};
</script>
